import { Module, Mutation, Action } from "vuex-module-decorators";
import { formatMonthDate } from "@/utils/common/date";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest, handlePaginationData } from "@/utils/request";
import { getCatalogFiltersWt } from "@/graphql/product.gql";
import {
  queryByCreateTime,
  queryCountByMonth,
  queryByCondition
} from "@/graphql/warehouse.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatByDate, getDateBefore36 } from "@/utils/common/date";
import type { PaginationDataState } from "@/types";
import { WarehouseRecordTypeEnums } from "@/enums/warehouse";
import { ProductFilterKeysEnums } from "@/enums/product";
import { GTGroupFixedOrgParam } from "@/enums/app";
import { initFilterSelect } from "@/utils/mall/mall";

export interface WarehouseExceptionState extends PaginationDataState {
  scanType: string;
  searchCondition: any;
  listDataMap: any;
}

const defaultSearchInstance = () => ({
  keyword: "",
  scanType: ""
});
@Module({ name: "WarehouseExceptionModule", namespaced: true })
export default class WarehouseExceptionModule
  extends PaginationModule<WarehouseExceptionState, RootState>
  implements WarehouseExceptionState {
  public listData: any[] = [];
  public scanType: string = ""; // 出入库类型
  public searchCondition: any = defaultSearchInstance(); // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据
  public listDataMap: { [key: string]: any[] } = {};

  @Mutation
  setListDataMapMutation({ key, data }: any = {}) {
    if (key) {
      this.listDataMap = Object.assign({}, this.listDataMap, { [key]: data });
    } else {
      this.listDataMap = {};
    }
  }
  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setScanTypeMutation(data: string) {
    this.scanType = data;
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }

  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = defaultSearchInstance();
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap = Object.assign({}, this.timeSumMap, { [key]: value });
    }
  }

  // 获取筛选数据
  @Action
  async getFilterDataAction() {
    const { productAttrList } = await queryRequest({
      query: getCatalogFiltersWt,
      variables: {
        request: {
          ...GTGroupFixedOrgParam,
          status: 1,
          fetchSize: 1000
        }
      }
    });
    const attrMap = {};
    const keys: string[] = Object.values(ProductFilterKeysEnums);
    for (let item of productAttrList) {
      attrMap[item.attrCode] = item;
    }
    let data = Object.keys(attrMap)
      .filter(key => keys.includes(key))
      .map(key => attrMap[key]);
    const { commit } = this.context;
    commit("setFilterDataMutation", initFilterSelect(data));
  }

  @Action
  async queryListAction({ start, end }) {
    const {
      state: { scanType }
    } = this.context;

    let data = await queryRequest({
      query: queryByCreateTime,
      variables: {
        scanType: scanType || undefined,
        start,
        end
      }
    });
    this.setListDataMapMutation({ key: formatMonthDate(start), data });
    console.log(this.listDataMap);
  }

  @Action
  async queryWarehouseExceptionCountByMonth(variables: {
    month: string | string[];
    scanType: string;
  }) {
    const data = await queryRequest({
      query: queryCountByMonth,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", { key: o.month, value: o });
    });
  }

  @Action
  async queryWarehouseExceptionByCondition(variables: {
    month: string | string[];
    scanType: string;
  }) {
    let { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: queryByCondition,
        variables
      })
    );
    return { data, totalCount };
  }
}
